export default "__VITE_ASSET__Cy8U0CGP__"